import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setRetrospectiveDay({ commit }, days) {
    commit(types.SET_DAYS, days)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  async getBrands({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getBrands', () =>
      http.get('brand/brands', {
        params: searchOptions
      })
    )
    commit(types.SET_BRANDS, r.data)
    return r.data
  },
  async getBrand({ commit, dispatch }, brand) {
    const r = await startLoading(dispatch, 'getBrand', () => http.get(`brand/brand?id=${brand}`))
    commit(types.SET_BRAND, r.data)
    return r.data
  },
  async createBrand({ commit, dispatch }, brand) {
    const r = await startLoading(dispatch, 'createBrand', () => http.post('brand/saveBrand', brand))
    return r.data
  },
  async updateBrand({ commit, dispatch }, brand) {
    const r = await startLoading(dispatch, 'updateBrand', () => http.post('brand/saveBrand', brand))
    return r.data
  },
  async getFranchisees({ commit, dispatch }, franchisor) {
    const r = await startLoading(dispatch, 'getFranchisees', () =>
      http.get(`brand/brandFranchisees?franchisor=${franchisor}`)
    )
    commit(types.SET_FRANCHISEES, r.data)
    return r.data
  },
  async getFranchiseeShops({ commit, dispatch }, franchisee) {
    const r = await startLoading(dispatch, 'getFranchiseeShops', () =>
      http.get(`brand/franchiseeShops?franchisee=${franchisee}`)
    )
    commit(types.SET_SHOPS, r.data)
    return r.data
  },
  resetPreferences({ commit }) {
    commit(types.RESET_PREFERENCES)
  },
  setPreference({ commit }, data) {
    commit(types.SET_PREFERENCE, data)
  },
  updatePreference({ commit }, data) {
    commit(types.UPDATE_PREFERENCE, data)
  },
  async getPreferences({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getPreferences', () =>
      http.get('brand/brandPreference', {
        params: data
      })
    )
    commit(types.SET_PREFERENCES, r.data)
    return r.data
  },
  async savePreferences({ commit, state }) {
    state.preferences.forEach(element => {
      if (element.changed) {
        let data = {
          brand: element.brand,
          brandPreferenceName: element.name,
          preference: element.value,
          brandPreferenceCategory: element.type,
          isInactive: element.isInactive
        }
        http.post('brand/saveBrandPreference', data)
      }
    })
    commit(types.RESET_PREFERENCE_CHANGE)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/brands/actions.js